let access_code_array;
let eap = {};
let revoked_agent;
$(document).ready(function () {
    // change for uglify
    if (page_info.template === 'start') {
        if (page_info.show_eap_url_modal) {
            $('#modal-eap-url-information-capture').modal({
                show: true,
                keyboard: false,
                backdrop: 'static'
            });
        }

        if (page_info.invalid_case_id) {
            $('#modal-eap-url-invalid-case-id').modal({
                show: true,
                keyboard: false,
                backdrop: 'static'
            });
        }

        $('#submit_eap_info').click(function (e) {
            e.preventDefault();
            const eap_url = new URL(window.location.href);
            eap.eap_first_name = $("input[name='eap_first_name']").val();
            eap.eap_last_name = $("input[name='eap_last_name']").val();
            eap.eap_email = $("input[name='eap_email']").val();
            eap.birth_month = $("select[name='birth_month']").val();
            eap.birth_day = $("select[name='birth_day']").val();
            eap.birth_year = $("select[name='birth_year']").val();
            eap.eap_access_code = $("#eap_access_code").val();

            if (eap_url.searchParams.get('invite_source')) {
                eap.invite_source = eap_url.searchParams.get('invite_source');
            } else if (eap_url.searchParams.get('eap_invite_source')) {
                eap.invite_source = eap_url.searchParams.get('eap_invite_source');
            } else if (page_info.eap_invite_source) {
                eap.invite_source = page_info.eap_invite_source;
            } else {
                eap.invite_source = '';
            }

            if (page_info.eap_landing_page) {
                eap.eap_code_name = page_info.eap_code_name;
                eap.eap_hash = page_info.eap_hash;
                eap.eap_sc = eap.eap_access_code;
            } else {
                eap.eap_code_name = eap_url.searchParams.get('eap_code_name');
                eap.eap_sc = eap_url.searchParams.get('eap_sc');
                eap.eap_hash = eap_url.searchParams.get('eap_hash');
                eap.eap_case_id = eap_url.searchParams.get('eap_case_id');
                eap.eap_employer = eap_url.searchParams.get('eap_organization');
                if (eap.eap_employer == null) {
                    eap.eap_employer = eap_url.searchParams.get('eap_employer');
                }
            }

            validate_eap_url_params(eap).then(function(eap) {
                if (!!eap && eap.eap_account_exists == false) {
                    //this loop is currently non-functional for anything beyond the current site it is called from --
                    //set_eap_invite_cookie api doesn't set a cookie, it sets the PHP session storage, however, you cannot set session storage on a different domain on prod
                    //leaving in as it is functional for RG and BH, but should be touched up
                    page_info['redirect_sites_fqdn'].forEach(function (site_fqdn) {
                        $.ajax({
                            url: 'https://' + site_fqdn + '/api/set_eap_invite_cookie/',
                            type: 'GET',
                            xhrFields: {withCredentials: true},
                            data: {
                                eap_first_name: eap.eap_first_name,
                                eap_last_name: eap.eap_last_name,
                                eap_email: eap.eap_email,
                                eap_code_name: eap.eap_code_name,
                                eap_sc: eap.eap_sc,
                                eap_case_id: eap.eap_case_id,
                                eap_hash: eap.eap_hash,
                                eap_access_code: eap.eap_access_code,
                                eap_employer: eap.eap_employer,
                                birth_month: eap.birth_month,
                                birth_day: eap.birth_day,
                                birth_year: eap.birth_year,
                                invite_source: eap.invite_source
                            }
                        }).always(function () {
                            window.location.reload();
                        });
                    });
                }
            });
        });

        const validate_eap_url_params = function(eap) {
            return new Promise(function(resolve, reject) {
                startBhLoadingAnimation();
                $.ajax({
                    url: '/api/eap_url_validate/',
                    type: 'POST',
                    data: {
                        action: 'validate',
                        csrf_token: page_info.csrf_token,
                        eap_first_name: eap.eap_first_name,
                        eap_last_name: eap.eap_last_name,
                        eap_email: eap.eap_email,
                        eap_code_name: eap.eap_code_name,
                        eap_sc: eap.eap_sc,
                        eap_hash: eap.eap_hash,
                        eap_access_code: eap.eap_access_code,
                        eap_case_id: eap.eap_case_id,
                        birth_month: eap.birth_month,
                        birth_day: eap.birth_day,
                        birth_year: eap.birth_year,
                        eap_employer: eap.eap_employer,
                        invite_source: eap.invite_source
                    }
                }).success(function (d) {
                    const data = JSON.parse(d);
                    if (!!data.errors) {
                        if (data.errors == 'invalid_email') {
                            $('#eap_invalid_input').text('Please enter a valid email');
                            $('#eap_invalid_input').removeClass('hidden').css('display', 'block');
                        } else if (data.errors == 'invalid_first_name') {
                            $('#eap_invalid_input').text('Please enter a first name');
                            $('#eap_invalid_input').removeClass('hidden').css('display', 'block');
                        } else if (data.errors == 'invalid_last_name') {
                            $('#eap_invalid_input').text('Please enter a last name');
                            $('#eap_invalid_input').removeClass('hidden').css('display', 'block');
                        } else if (data.errors == 'invalid_access_code') {
                            $('#eap_invalid_input').text('Please enter a valid access code');
                            $('#eap_invalid_input').removeClass('hidden').css('display', 'block');
                        } else if (data.errors == 'invalid_dob') {
                            $('#eap_invalid_input').text('Please enter a valid date of birth');
                            $('#eap_invalid_input').removeClass('hidden').css('display', 'block');
                        }
                    } else {
                        if (data.account_exists) {
                            $('#modal-eap-url-information-capture').modal('hide');
                            $('#modal-eap-url-information-confirm').modal({
                                show: true,
                                keyboard: false,
                                backdrop: 'static'
                            });
                        } else {
                            $('#modal-eap-url-information-capture').modal('hide');
                            if (!eap.eap_case_id) {
                                eap.eap_case_id = data.eap_case_id;
                            }
                        }
                        eap.eap_account_exists = data.account_exists;
                    }
                    resolve(eap);
                }).always(function () {
                    stopBhLoadingAnimation();
                });
            });
        };
    }

    if (page_info.template.indexOf('eap_invite') > 0) {
        let required_fields = ['first_name', 'email', 'case_id', 'weeks_covered'];
        if (page_info.lock_access_codes) {
            required_fields.push('access_code');
        }
        $("#email").on('change', function() {
            $("#review_email").text($("#email").val());
        });

        $("#service").on('change', function() {
            $("#review_service").text($("#service option:selected").text());
        });

        $("#weeks_covered").on('change', function () {
            $("#weeks").text($("#weeks_covered").val());
        });

        $('#resend_inv_email').click(function () {
            $('#resend_case_id_label').text($('#case_id').parent().find('label').text());
            $('#modal-eap-resend-invite').modal('show');
            $("#resend_invite_errors").text("");
            $("#resend_invite_errors").addClass('hidden');
        });

        $('#btn-submit-reinvite').click(function() {
            $('#resend_invite_success').addClass('hidden');
            $("#resend_invite_errors").addClass('hidden');
            $("#modal-please-wait").modal('show');
            $.ajax({
                url: "/api/eap_get_data/",
                data: {
                    email: $('#resend_email').val(),
                    case_id: $("#resend_case_id").val(),
                    eap_admin_id: page_info.eap_admin_id,
                    csrf_token: page_info.csrf_token,
                    action: 'resend_invite'
                },
                type: "POST"
            }).success(function (data) {
                const result = JSON.parse(data);
                if (result['status'] == 'failure') {
                    $("#resend_invite_errors").text("An error occurred, please try again later");
                    $("#resend_invite_errors").removeClass('hidden');
                } else if (result['response']['account_exists']) {
                    $("#resend_invite_errors").text("Client account already exists");
                    $("#resend_invite_errors").removeClass('hidden');
                } else if (result['response']['not_found']) {
                    $("#resend_invite_errors").text("Could not find user with information provided");
                    $("#resend_invite_errors").removeClass('hidden');
                } else {
                    $('#resend_invite_success').removeClass('hidden');
                    $("#resend_case_id").val('');
                    $("#resend_email").val('');
                    $("#resend_invite_errors").text("");
                    $("#resend_invite_errors").addClass('hidden');
                }
            }).always(function() {
                $("#modal-please-wait").modal('hide');
            });
        });

        $("#btn-submit-invite").on('click', function() {
            $("#invite_form").submit();
            $('#access_code_list').empty();
        });

        $("#review_button").on('click', function() {
            $('.alert-success').addClass('hidden');
            let has_error = false;
            required_fields.forEach(function(item) {
                if ($("#" + item).val().length == 0) {
                    $("#" + item).parent().addClass('has-error');
                    $(".alert-danger").text("Please fill all the required fields");
                    $(".alert-danger").removeClass('hidden');
                    has_error = true;
                } else if (!has_error) {
                    $("#" + item).parent().removeClass('has-error');
                }
            });

            if ($('.sap_invitee_type').length) {
                if ($('.sap_invitee_type:checked').val() === undefined) {
                    $('.sap_invitee_type').parent().addClass('has-error');
                    $('.alert-danger').text('Please fill all the required fields');
                    $('.alert-danger').removeClass('hidden');
                    has_error = true;
                }
            }

            if (!has_error) {
                if ($('.sap_invitee_type').length) {
                    $('#invitee_type').text($('.sap_invitee_type:checked').closest('label').text().trim());
                }
                $("#modal-review-eap-invite").modal("show");
                $(".alert-danger").text("");
                $(".alert-danger").addClass('hidden');
            }
            return false;
        });

        $('#eap_access').on('change', function() {
            if (page_info.eap_admin_id !== $(this).val()) {
                window.location.href = '/eap_invite/?id=' + $(this).val();
            }
        });
    }

    if (page_info.template.indexOf('eap_uninvite') > 0) {
        $("#review_uninvite_button").on('click', function () {
            $(".alert-danger").text("");
            $(".alert-danger").addClass('hidden');
            $('#case_id_label').text();
            let has_error = false;

            if ($("#case_id").val().length == 0) {
                $("#case_id").parent().addClass('has-error');
                $(".alert-danger").text("Please fill all the required fields");
                $(".alert-danger").removeClass('hidden');
                has_error = true;
            }

            if ($("#email").val().length == 0) {
                $("#email").parent().addClass('has-error');
                $(".alert-danger").text("Please fill all the required fields");
                $(".alert-danger").removeClass('hidden');
                has_error = true;
            }

            if (!has_error) {
                $("#modal-please-wait").modal('show');
                $.ajax({
                    url: "/api/eap_get_data/",
                    data: {
                        email: $('#email').val(),
                        case_id: $("#case_id").val(),
                        eap_admin_id: page_info.eap_admin_id,
                        csrf_token: page_info.csrf_token,
                        action: 'uninvite'
                    },
                    type: "POST",
                }).success(function (data) {
                    let result = JSON.parse(data);
                    if (result['status'] == 'failure') {
                        $(".alert-danger").text("An error occurred, please try again later");
                        $(".alert-danger").removeClass('hidden');
                    } else if (result['response']['not_found']) {
                        $(".alert-danger").text("Could not find user with information provided");
                        $(".alert-danger").removeClass('hidden');
                    } else {
                        $("#modal-review-eap-uninvite").modal("show");
                        $("#uninvite_email").text(result['response']['email']);
                        $("#uninvite_first_name").text(result['response']['first_name']);
                        $("#uninvite_case_id").text(result['response']['case_id']);
                        $(".alert-danger").text("");
                        $(".alert-danger").addClass('hidden');
                    }
                }).always(function () {
                    $("#modal-please-wait").modal('hide');
                });
            }
            return false;
        });

        $("#btn-submit-uninvite").on('click', function () {
            $("#uninvite_form").submit();
        });

        $('#eap_access').on('change', function() {
            if (page_info.eap_admin_id !== $(this).val()) {
                window.location.href = '/eap_uninvite/?id=' + $(this).val();
            }
        });
    }

    if (page_info.template == '/eap/eap_account_settings') {
        $('#secret_tooltip').tooltip({placement: 'top'}).attr('data-original-title',
            "EAP Secret token is used for BetterHelp's API integration. See implementation document for further details."
        );
        $('#secret_tooltip').on('mouseover', function() {
            $('#secret_tooltip').tooltip('show');
        });

        $('#eap_access_settings').on('change', function() {
            if (page_info.eap_admin_id !== $(this).val()) {
                window.location.href = '/eap_account_settings/?id=' + $(this).val();
            }
        });

        $('#download_data').click(function() {
            const data_month = $('#data_month').val();
            const data_year = $('#data_year').val();
            $('.download-data .alert-danger').addClass('hidden');
            if (!data_month) {
                $('.download-data').prepend('<div class="alert alert-danger">Please select a valid month</div>');
            } else if (!data_year) {
                $('.download-data').prepend('<div class="alert alert-danger">Please select a valid year</div>');
            } else {
                $('#modal-eap-admin-data-download-agreement').modal('show');
            }
        });

        $('#confirm-agreement').click(function() {
            const data_month = $('#data_month').val();
            const data_year = $('#data_year').val();
            window.location.href = '/eap_account_data_download/?month=' + data_month + '&year=' + data_year;
            $('#modal-eap-admin-data-download-agreement').modal('hide');
        });

        $('#data_month').on('change', function() {
            if ($(this).val() == '') {
                $('#download_data').prop('disabled', true);
            } else if ($(this).val() != '' && $('#data_year').val() != '') {
                $('#download_data').prop('disabled', false);
            }
        });

        $('#data_year').on('change', function() {
            if ($(this).val() == '') {
                $('#download_data').prop('disabled', true);
            } else if ($(this).val() != '' && $('#data_month').val() != '') {
                $('#download_data').prop('disabled', false);
            }
        });

        $('#all_eap_access_ids').click(function () {
            if ($(this).is(':checked')) {
                $('.eap_access_ids').prop('checked', true);
            } else {
                $('.eap_access_ids').prop('checked', false);
            }
        });

        $('.eap_access_ids').click(function () {
            if ($('.eap_access_ids:checked').length === $('.eap_access_ids').length) {
                $('#all_eap_access_ids').prop('checked', true);
            } else {
                $('#all_eap_access_ids').prop('checked', false);
            }
        });

        $('#add_new_agent').click(function() {
            $('.contact-form .alert-danger').addClass('hidden');
            $('.contact-form .alert-success').addClass('hidden');
            if (!$('#new_agent_email').val()) {
                return;
            }
            startBhLoadingAnimation();
            $.ajax({
                url: '/api/eap_account_data/',
                type: "POST",
                data: {
                    action: 'add_agent',
                    email: $('#new_agent_email').val().trim(),
                    csrf_token: page_info.csrf_token
                }
            }).success(function(data) {
                data = JSON.parse(data);
                if (!!data.errors) {
                    if (data.errors.includes('invalid_email')) {
                        $('#new_agent_email').closest('.contact-form').prepend('<div class="alert alert-danger">Please enter a valid email</div>');
                    } else if (data.errors.includes('not_bug_bounty')) {
                        $('#new_agent_email').closest('.contact-form').prepend('<div class="alert alert-danger">Sorry, only bug bounty emails allowed.</div>');
                    } else if (data.errors.includes('outside_eap')) {
                        $('#new_agent_email').closest('.contact-form').prepend('<div class="alert alert-danger">Please contact support to add this agent</div>');
                    }
                } else {
                    const new_agent_email = escape_html($('#new_agent_email').val().trim());
                    $('#confirm_eap_agents_access').val(new_agent_email);
                    $('#all_eap_access_ids, .eap_access_ids').prop('checked', true);
                    $('#eap-agents-access-modal').modal('show');
                    const existing_row = $("td").filter(function () {
                        return $(this).text() == new_agent_email;
                    }).closest("tr");
                    if (existing_row.length > 0) {
                        $(existing_row).find('.center').text('');
                        $(existing_row).find('.center').append('<button data-email="' + new_agent_email + '" class="btn btn-sm btn-success" id="agent_eap_access_' + ($('tbody tr').length - 1) + '">Manage Access</button> <button data-email="' + new_agent_email + '" class="btn btn-sm btn-danger ml-15" id="revoke_access_' + ($('tbody tr').length - 1) + '">Revoke Access</button>');
                    } else {
                        $('#new_agent_email').closest('table').find('tr:last').prev().after('<tr><td>' + new_agent_email + '</td><td class="center"><button data-email="' + new_agent_email + '" class="btn btn-sm btn-success" id="agent_eap_access_' + ($('tbody tr').length - 1) + '">Manage Access</button> <button data-email="' + new_agent_email + '" class="btn btn-sm btn-danger ml-15" id="revoke_access_' + ($('tbody tr').length - 1) + '">Revoke Access</button></td></tr>');
                    }
                    $('#new_agent_email').closest('.contact-form').prepend('<div class="alert alert-success">Agent ' + new_agent_email + ' added</div>');
                    $('#new_agent_email').val('');
                }
            }).always(function() {
                stopBhLoadingAnimation();
            });
        });
        $('#confirm_eap_agents_access').click(function() {
            const eaps_access_removed = $('.eap_access_ids:not(:checked)').map(function() {
                return $(this).val();
            }).get();
            const eaps_access_granted = $('.eap_access_ids:checked').map(function() {
                return $(this).val();
            }).get();
            if (eaps_access_removed.length === $('.eap_access_ids').length) {
                $('#eap_access_selection_error').removeClass('hidden');
                return false;
            } else {
                $('#eap_access_selection_error').addClass('hidden');
            }
            const agent_email = $(this).val();
            startBhLoadingAnimation();
            $.ajax({
                url: '/api/eap/add-eap-access/',
                type: "POST",
                data: {
                    email: agent_email,
                    eaps_access_removed: eaps_access_removed,
                    eaps_access_granted: eaps_access_granted,
                    csrf_token: page_info.csrf_token
                }
            }).success(function(data) {
                $('#eap-agents-access-modal').modal('hide');
            }).always(function() {
                stopBhLoadingAnimation();
            });
        });
        $(document).on('click', '[id^="agent_eap_access"]', function() {
            const email = $(this).data('email');
            startBhLoadingAnimation();
            $.ajax({
                url: "/api/eap/get-agent-eap-access-details",
                data: {
                    email: email,
                    csrf_token: page_info.csrf_token
                },
                type: "POST"
            }).success(function (data) {
                if (data.response.length > 0) {
                    $('#all_eap_access_ids, .eap_access_ids').prop('checked', false);
                    data.response.forEach(function(item) {
                        $('.eap_access_ids[value="' + item.eap_admin_id + '"]').prop('checked', true);
                    });
                    if (data.response.length === $('.eap_access_ids').length) {
                        $('#all_eap_access_ids').prop('checked', true);
                    } else {
                        $('#all_eap_access_ids').prop('checked', false);
                    }
                }
                $('#confirm_eap_agents_access').val(email);
                $("#eap-agents-access-modal").modal('show');
            }).always(function() {
                stopBhLoadingAnimation();
            });
        });
        $(document).on('click', '[id^="revoke_access"]', function() {
            revoked_agent = $(this).attr('id');
            $('#revoke_for_text').text('');
            $('#revoke_for_text').append('This action will revoke access for <strong>' + escape_html($('#' + revoked_agent).data('email')) + '</strong>');
            $('#confirm-eap-agent-revoke-modal').modal({
                show: true,
                keyboard: false,
                backdrop: 'static'
            });
        });

        $('#confirm_revoke_access').click(function() {
            $('.contact-form .alert-danger').addClass('hidden');
            $('.contact-form .alert-success').addClass('hidden');
            startBhLoadingAnimation();
            $.ajax({
                url: '/api/eap_account_data/',
                type: "POST",
                data: {
                    action: 'revoke_agent',
                    email: $('#' + revoked_agent).data('email'),
                    csrf_token: page_info.csrf_token
                }
            }).success(function(data) {
                data = JSON.parse(data);
                if (!!data.errors) {
                    if (data.errors.includes('invalid_email')) {
                        $('#' + revoked_agent).closest('.contact-form').prepend('<div class="alert alert-danger">Please select the correct agent to revoke</div>');
                    }
                } else {
                    $('#confirm-eap-agent-revoke-modal').modal('hide');
                    $('#' + revoked_agent).closest('.contact-form').prepend('<div class="alert alert-success">Revoked agent ' + escape_html($('#' + revoked_agent).data('email')) + '</div>');
                    $('#' + revoked_agent).closest('td').text('Revoked');
                    $('#' + revoked_agent).hide();
                }
            }).always(function() {
                stopBhLoadingAnimation();
            });
        });

        $('#secret_toggle').click(function() {
            if ($('#eap_secret').is(':visible')) {
                $('#eap_secret_mask').removeClass('hidden');
                $('#eap_secret').addClass('hidden');
                $('#secret_toggle').text('Show Secret Token');
            } else {
                $('#eap_secret').removeClass('hidden');
                $('#eap_secret_mask').addClass('hidden');
                $('#secret_toggle').text('Hide Secret Token');
            }
        });
    }

    if (page_info.template == '/eap/eap_refer_api_settings') {
        $('#refer_api_key_tooltip').tooltip({placement: 'top'}).attr('data-original-title',
            "These API keys are used for BetterHelp's Refer API integration. See implementation document for further details."
        );
        $('#refer_api_key_tooltip').on('mouseover', function() {
            $('#refer_api_key_tooltip').tooltip('show');
        });

        $('#revoke_refer_api_access_btn').click(function() {
            $('#modal-revoke-refer-api-access-agreement').modal('show');
        });

        $('#eap_access_settings').on('change', function() {
            if (page_info.eap_admin_id !== $(this).val()) {
                window.location.href = '/eap_refer_api_settings/?id=' + $(this).val();
            }
        });

        $('#confirm_revoke_refer_api_access_agreement').click(function() {
            const confirmationMessageInput = $('#revoke-refer-api-confirmation');
            const referApiKeyHeaderSection = $('#refer_api_key_header');
            const revokeReferApiKeyModal = $('#modal-revoke-refer-api-access-agreement');

            if (confirmationMessageInput.val() !== 'revoke') {
                if (!$('#revoke-refer-api-confirmation-error').length) {
                    confirmationMessageInput.parent('.modal-body').append('<div id="revoke-refer-api-confirmation-error" class="alert alert-danger">Please type in correct phrase</div>');
                }
                return;
            }

            startBhLoadingAnimation();
            $.ajax({
                url: '/api/eap_account_data/',
                type: "POST",
                data: {
                    action: 'revoke_refer_api_access',
                    csrf_token: page_info.csrf_token
                }
            }).success(function(data) {
                data = JSON.parse(data);
                if (!!data.errors) {
                    referApiKeyHeaderSection.prepend('<div class="alert alert-danger">Something went wrong. Please contact support</div>');
                    stopBhLoadingAnimation();
                    revokeReferApiKeyModal.modal('hide');
                } else {
                    window.location.reload();
                }
            }).error(function() {
                referApiKeyHeaderSection.prepend('<div class="alert alert-danger">Something went wrong. Please contact support</div>');
                stopBhLoadingAnimation();
                revokeReferApiKeyModal.modal('hide');
            });
        });

        $('#new_refer_api_key_btn').click(function() {
            $('#modal-new-refer-api-key-agreement').modal('show');
        });

        $('#confirm_new_refer_api_key_saved').click(function() {
            startBhLoadingAnimation();
            window.location.reload();
        });

        $('#confirm_new_refer_api_key_agreement').click(function() {
            const referApiKeyHeaderSection = $('#refer_api_key_header');
            const newReferApiKeyModal = $('#modal-new-refer-api-key-agreement');

            startBhLoadingAnimation();
            $.ajax({
                url: '/api/eap_account_data/',
                type: "POST",
                data: {
                    action: 'create_new_refer_api_key',
                    csrf_token: page_info.csrf_token
                }
            }).success(function(data) {
                data = JSON.parse(data);
                if (!!data.errors) {
                    if (data.errors.includes('refer_api_key_max_limit')) {
                        referApiKeyHeaderSection.prepend('<div class="alert alert-danger">You have reached the limit for Refer API Keys</div>');
                    } else {
                        referApiKeyHeaderSection.prepend('<div class="alert alert-danger">Please contact support to make a new Refer API Key</div>');
                    }
                    stopBhLoadingAnimation();
                    newReferApiKeyModal.modal('hide');
                } else {
                    newReferApiKeyModal.find('.new-token-value').text(data.results.key);
                    newReferApiKeyModal.find('.create-token-text').hide();
                    newReferApiKeyModal.find('.create-token-actions').hide();
                    newReferApiKeyModal.find('.new-token-text').show();
                    newReferApiKeyModal.find('.new-token-actions').show();
                    stopBhLoadingAnimation();
                }
            }).error(function() {
                referApiKeyHeaderSection.prepend('<div class="alert alert-danger">Please contact support to make a new Refer API Key</div>');
                stopBhLoadingAnimation();
                newReferApiKeyModal.modal('hide');
            });
        });

        $('.refer_api_key_delete').click(function(event) {
            const referApiKeyId = $(event.currentTarget).data('refer-api-key-id');
            $('#modal-delete-refer-api-key-agreement').data('refer-api-key-id', referApiKeyId).modal('show');
        });

        $('#confirm_delete_refer_api_key_agreement').click(function(event) {
            const referApiKeyHeaderSection = $('#refer_api_key_header');
            const deleteReferApiKeyModal = $('#modal-delete-refer-api-key-agreement');
            const referApiKeyId = Number(deleteReferApiKeyModal.data('refer-api-key-id'));

            startBhLoadingAnimation();
            $.ajax({
                url: '/api/eap_account_data/',
                type: "POST",
                data: {
                    action: 'delete_refer_api_key',
                    refer_key_id: referApiKeyId,
                    csrf_token: page_info.csrf_token
                }
            }).success(function(data) {
                data = JSON.parse(data);
                if (!!data.errors) {
                    referApiKeyHeaderSection.prepend('<div class="alert alert-danger">Please contact support to delete this Refer API Key</div>');
                    stopBhLoadingAnimation();
                    deleteReferApiKeyModal.modal('hide');
                } else {
                    window.location.reload();
                }
            }).error(function() {
                referApiKeyHeaderSection.prepend('<div class="alert alert-danger">Please contact support to delete this Refer API Key</div>');
                stopBhLoadingAnimation();
                deleteReferApiKeyModal.modal('hide');
            }).always(function() {
                deleteReferApiKeyModal.data('refer-api-key-id', '');
            });;
        });
    }

    if (page_info.template == '/eap/eap_account_settings' || page_info.template.indexOf('eap_uninvite') > 0 || page_info.template.indexOf('eap_invite') > 0 || page_info.template == '/eap/eap_extension_requests') {
        $(window).on('resize', function() {
            if ($(window).width() > 767) {
                $('.main').show();
            } else {
                $('.main').hide();
            }
        });

        if ($('.mobilemenu-toggle').is(':visible')) {
            $('.main').hide();
        }

        $('.fa-bars').click(function() {
            $('.main').toggle();
        });
    }

    if (page_info.template == '/eap/eap_invite_base') {
        $('#eap_uninvite_tooltip').tooltip({placement: 'top'}).attr('data-original-title',
            "Remove benefits from a member"
        );
        $('#resend_inv_email').tooltip({placement: 'top'}).attr('data-original-title',
            "Resend invite email without changing the referral"
        );
        $('#eap_uninvite_tooltip, #resend_inv_email').on('mouseover', function () {
            $(this).tooltip('show');
        });
    }

    if (page_info.template == '/eap/eap_verify') {
        $('#resend_verification_code').click(function () {
            $('#resend_verification_code_input').val('1');
            $('#eap_verify_form').submit();
        });
    }

    if (page_info.template == '/eap/eap_extension_requests') {

        let showExtensionResponseBanner = (currentRequestId) => {
            $('.extension-request-banner').not('.hidden').remove();
            const currentBanner = $('#extension-request-banner-' + currentRequestId + '.extension-request-banner')
            currentBanner.removeClass('hidden');
            currentBanner.prependTo('.extension-request-container');
            $('#extension-request-' + currentRequestId + '.extension-request-wrapper').remove();
        }

        // global 'state' values
        let currentRequestId = null;
        let currentRequestType = null;

        $('.extension-request-button[data-eap-request-type]').on('click', function(e) {
            e.preventDefault();

            currentRequestId = $(this).attr('data-eap-extension-request-id')
            currentRequestType = $(this).attr('data-eap-request-type');

            $('#eap-agent-confirm-extension-request #eap-agent-confirm-extension-request-case-id').text($('#' + currentRequestId).attr('data-case-id'));

            let titleText;
            let copyText;

            switch (currentRequestType) {
                case "approve":
                    titleText = 'approval';
                    copyText = 'approve';
                    break;
                case "reject":
                    titleText = 'rejection';
                    copyText = 'reject';
                    break;
                default:
                    titleText = 'action';
                    copyText = 'action';
                    break;
            }

            $('#eap-agent-confirm-extension-request #action-title-text').text(titleText);
            $('#eap-agent-confirm-extension-request #action-copy-text').text(copyText);

            $('#eap-agent-confirm-extension-request #eap-agent-confirm-extension-request-number-of-sessions').text($('#extension-request-' + currentRequestId).attr('data-number-of-sessions'));
            $('#eap-agent-confirm-extension-request #eap-agent-confirm-extension-request-case-id').text($('#extension-request-' + currentRequestId).attr('data-case-id'));

            $('#eap-agent-confirm-extension-request').modal('toggle');
        });

        $('#eap-agent-confirm-extension-request #eap-agent-confirm-extension-request-button').on('click', function() {
            $("#eap-extension-request-error").text("");
            $("#eap-extension-request-error-wrapper").addClass('hidden');
            switch (currentRequestType) {
                case "approve":
                    $.post('/api/eap/approve-extension-request/', {
                        eap_extension_request_id: currentRequestId,
                        csrf_token: page_info.csrf_token
                    })
                    .done(function(data) {
                        $('#extension-request-banner-' + currentRequestId + ' #alert-banner-text').text('approved')
                        showExtensionResponseBanner (currentRequestId);
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        let msg = jqXHR?.responseJSON?.message ?? "Failed to approve extension request";
                        $("#eap-extension-request-error").text(msg);
                        $("#eap-extension-request-error-wrapper").removeClass('hidden');
                    });
                    break;
                case "reject":
                    $.post('/api/eap/deny-extension-request/', {
                        eap_extension_request_id: currentRequestId,
                        csrf_token: page_info.csrf_token
                    })
                    .done(function(data) {
                        $('#extension-request-banner-' + currentRequestId + ' #alert-banner-text').text('rejected');
                        showExtensionResponseBanner(currentRequestId);
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        $("#eap-extension-request-error").text("Failed to deny extension request");
                        $("#eap-extension-request-error-wrapper").removeClass('hidden');
                    });

                    break;
                default:
                    titleText = 'action'
                    break;
            }

            $('#eap-agent-confirm-extension-request').modal('toggle');
        })

        // eap notice banner
        $('.close[data-eap-extension-request-id]').on('click', function() {
            let closeId = $(this).attr('data-eap-extension-request-id');

            $('#extension-request-banner-' + closeId).remove();

            if ($('.close[data-eap-extension-request-id]').length === 0) {
                $('.extension-request-empty').removeClass('hidden');
            }
        });

        // Error alert
        $('.error-close').on('click', function() {
            let closeId = $(this).attr('data-eap-extension-request-id');
            $("#eap-extension-request-error").text("");
            $("#eap-extension-request-error-wrapper").addClass('hidden');
        });
    }
});




//-----------------------------------------------------------------------------
//                                 Select2
//-----------------------------------------------------------------------------

// We dynamically load all our select2 JS/CSS dependencies in here so we can use load eap.js as a single file that brings in its own dependencies
$(document).ready(function (){
  //--------------------
  // Select2
  //--------------------
  let access_codes_select = $('select.eap_access_code_dropdown');
  access_codes_select.select2({
    dropdownCssClass: 'select2-container--tall',
    width: '100%', // necessary for modal dropdown to render properly
    theme: "bootstrap4", // necessary for modal dropdown to render properly
    minimumInputLength: 3,
    ajax: {
      url: '/api/eap_get_access_codes/',
      dataType: 'json',
      type: "GET",
      data: function (params) {
        return {
        eap_admin_id: page_info.eap_admin_id,
        eap_access_code_string: params.term, // the current select2 search term
        }
      },
      processResults: function (data) {
        if (data.errors) {
             if (data.errors[0] == 'missing_eap_access_code_string') {
               $(".alert-danger").text("Missing or invalid employer name / access code");
               $(".alert-danger").removeClass('hidden');
             } else {
               $(".alert-danger").text("An error occurred, please try again later");
               $(".alert-danger").removeClass('hidden');
             }
        }
        return data;
      },
    },
    // tags, createTag, and templateResult work together to allow users to enter a new access code that isn't in our existing list
    // new access codes entered in this way will not be created on the backend, they are just invalid access codes
    // this behavior is only allowed when access codes have not been "locked" on the backend
    tags: (function () {
      return !page_info.lock_access_codes && page_info.template.indexOf('eap_invite') > 0;
    })(),
    createTag: function (params) {
      // data structure for adding a new entry to the dropdown when it doesn't match any search results
      return {
        id: params.term,
        text: params.term,
        newOption: true
      }
    },
    templateResult: function (data) {
      // how to display the new option in the dropdown to indicate it doesn't match any search results
      let $result = $("<span></span>");
      $result.text(data.text);
      if (data.newOption) {
        $result.append(" <em>(no matches found)</em>");
      }
      return $result;
    },

    // this is necessary for select2 to work in a bootstrap modal (landing page)
    // More info at https://select2.org/troubleshooting/common-problems#select2-does-not-function-properly-when-i-use-it-inside-a-bootst
    dropdownParent: (function () {
      if (page_info.template === 'start') {
        return $('#modal-eap-url-information-capture .modal-content')
      }
    })(),

    });


  // Select2's change event
  access_codes_select.on("select2:select", function (e) {
    let default_weeks = e.params.data.default_weeks;
    $('#weeks_covered').val(default_weeks);
    $("#weeks").text(default_weeks);
    $('#access_code_review').text(e.params.data.text);
  });

  // hacky fixes for bad select2 behavior in modals (aka landing page)
  if (page_info.template === 'start') {
    // fix broken autofocus in modals. This is fixed in jquery3.7.0, details at https://github.com/select2/select2/issues/5993#issuecomment-1115893633
    access_codes_select.on('select2:open', () => {
      setTimeout(() => document.querySelector('.select2-search__field').focus(), 200);
    });

    // Fix broken dropdown arrow CSS in modals
    let modal_style_fix = `
        #access_code_dropdown .select2-container .select2-selection .select2-selection__arrow b:before {
            display: none !important
        }

        #access_code_dropdown .select2-container .select2-selection .select2-selection__arrow {
            height: 0% !important;
        }
    `
    let styleSheet = document.createElement("style");
    styleSheet.innerText = modal_style_fix;
    document.head.appendChild(styleSheet);
  }
});


